module.exports = __webpack_public_path__ + "img/insta.b8258cad.svg";